import React, { FC } from 'react';

export const PanelContainer: FC = ({ children }) => (
  <div id="panelContainer">{children}</div>
);
